import { render, staticRenderFns } from "./Dizhi_Duoxuan.vue?vue&type=template&id=5008ca1a&"
import script from "./Dizhi_Duoxuan.vue?vue&type=script&lang=js&"
export * from "./Dizhi_Duoxuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports